import * as React from "react";
import { useGetIdentity } from "react-admin";
import { Avatar, CircularProgress } from "@mui/material";
import PlayerIdentityRow from "../profile/PlayerIdentityRow";

const makeAbsolute = (url?: string | null) => {
  if (!url) return undefined;
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_CDN_URL ?? ""}/static/avatars/${url}`;
};

export function UserAvatarIcon(props: { size?: number }) {
  const { size = 30 } = props;
  const { identity, isLoading } = useGetIdentity();

  if (isLoading || !identity) {
    return (
      <Avatar sx={{ width: size, height: size }}>
        <CircularProgress size={Math.max(14, Math.floor(size * 0.5))} />
      </Avatar>
    );
  }


  const first = (identity as any)?.first_name ?? "";
  const last = (identity as any)?.last_name ?? "";
  const email = (identity as any)?.email ?? "";
  const points = (identity as any)?.points ?? "";
  const initials =
    `${first} ${last}`
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((s) => s[0])
      .slice(0, 2)
      .join("")
      .toUpperCase() || "?";

  const avatarUrl = makeAbsolute((identity as any)?.avatar_url ?? null);

  return (
      <PlayerIdentityRow
        firstName={first}
        lastName={last}
        email={undefined}
        points={points}
        avatarUrl={avatarUrl}
        showPoints={false}
        size="xs"
        showName={false}
      />

    //<Avatar src={avatarUrl} sx={{ width: size, height: size, fontWeight: 700 }}>
    //  {initials}
    //</Avatar>
  );
}
